import React, { createContext, useContext, useState, useCallback } from 'react';

const BarcodeScannerContext = createContext(null);

export const useBarcode = () => {
  const context = useContext(BarcodeScannerContext);
  if (!context) {
    throw new Error('useBarcode must be used within BarcodeScannerProvider');
  }
  return context;
};

export const BarcodeScannerProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [onScanCallback, setOnScanCallback] = useState(null);

  const openScanner = useCallback((callback) => {
    setOnScanCallback(() => callback);
    setIsOpen(true);
  }, []);

  const closeScanner = useCallback(() => {
    setIsOpen(false);
    setOnScanCallback(null);
  }, []);

  const handleScan = useCallback((barcode) => {
    if (onScanCallback) {
      onScanCallback(barcode);
    }
    // Don't close - stay open for multiple scans as per user requirement
  }, [onScanCallback]);

  return (
    <BarcodeScannerContext.Provider value={{ isOpen, openScanner, closeScanner, handleScan }}>
      {children}
    </BarcodeScannerContext.Provider>
  );
};
